import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Trust } from './components/Trust';
import { Services } from './components/Services';
import { AISection } from './components/AISection';
import { Benefits } from './components/Benefits';
import { Results } from './components/Results';
import { Process } from './components/Process';
import { Testimonials } from './components/Testimonials';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white font-opensans text-slate-800 selection:bg-brand-cyan/30 selection:text-brand-black" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Trust data-id="element-4" />
        <Services data-id="element-5" />
        <AISection data-id="element-6" />
        <Benefits data-id="element-7" />
        <Results data-id="element-8" />
        <Process data-id="element-9" />
        <Testimonials data-id="element-10" />
        <FinalCTA data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
    </div>;
}